import { useLayoutEffect, useState } from "react";

/**
 * True when the element's text overflows horizontally (ellipsis active).
 */
export function useIsTextOverflowing(ref, deps = []) {
  const [overflowing, setOverflowing] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const measure = () => {
      setOverflowing(el.scrollWidth > el.clientWidth);
    };

    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- caller passes dep array
  }, deps);

  return overflowing;
}
